import * as React from 'react';
import {StyleSheet, View, ViewStyle} from 'react-native';

import LabelListItem, {Entity} from './LabelListItem';

import DragScrollView from '../../../../../shared/drag_scroll_view';

interface Props<E extends Entity> {
  entities: E[] | null;
  selectedEntityId: number;
  visible: boolean;
  onSelectEntity: (entity: E) => void;
  extractLabel?: (entity: E) => string;
}

export default class LabelList<E extends Entity> extends React.PureComponent<
  Props<E>
> {
  public render(): React.ReactNode {
    const {entities, selectedEntityId, visible, onSelectEntity, extractLabel} =
      this.props;
    return (
      <DragScrollView
        style={visible ? null : styles.hide}
        horizontal={true}
        bounces={false}
        showsHorizontalScrollIndicator={false}>
        <View style={styles.container}>
          {(entities || []).map(entity => (
            <LabelListItem
              key={entity.id}
              entity={entity}
              checked={entity.id === selectedEntityId}
              onSelectEntity={onSelectEntity}
              extractLabel={extractLabel}
            />
          ))}
        </View>
      </DragScrollView>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginTop: 10,
    overflow: 'hidden',
    paddingHorizontal: 7,
    height: 50,
  } as ViewStyle,
  hide: {
    display: 'none',
  } as ViewStyle,
});
